/**
 * Creature size.
 * RULE DCC-SIZE-001 - Crawlers & Customization p.16, Table 10.
 * Humans are typically Medium (4). Animal crawlers range from size 2 to 4.
 * Size matters when attacking foes much larger or smaller than you
 * (Rules for Survival p.36), which is not implemented yet.
 */
import type { CrawlerType } from '../domain/character.ts';

export const SIZE_NAMES: Record<number, string> = {
  1: 'Tiny',
  2: 'Small',
  3: 'Petite',
  4: 'Medium',
  5: 'Large',
};

export const HUMAN_CRAWLER_SIZE = 4;
export const ANIMAL_CRAWLER_SIZES: readonly number[] = [2, 3, 4];

export function legalSizesFor(crawlerType: CrawlerType): readonly number[] {
  return crawlerType === 'human' ? [HUMAN_CRAWLER_SIZE] : ANIMAL_CRAWLER_SIZES;
}

export function isLegalSize(crawlerType: CrawlerType, size: number): boolean {
  return legalSizesFor(crawlerType).includes(size);
}

export function sizeName(size: number): string {
  return SIZE_NAMES[size] ?? 'Unknown';
}
